import { z } from 'zod'

// Строка отчёта: сколько встреч у субъекта среза и сколько времени он провёл в
// звонках. Время — сумма сессий присутствия. privateMeetingCount — сколько
// встреч строки учтено числами без раскрытия темы и состава.
export const ReportTotalsSchema = z.object({
  meetingCount: z.number().int().nonnegative(),
  seconds: z.number().nonnegative(),
  privateMeetingCount: z.number().int().nonnegative().default(0),
})
export type ReportTotals = z.infer<typeof ReportTotalsSchema>

// Пустой projectId — встречи вне проектов («Без проекта»), они входят в итог
// сотрудника наравне с остальными. Имя приходит из проекции хаба; пусто, если
// запись ещё не досинкана — потребитель падает на id.
export const ProjectReportRowSchema = ReportTotalsSchema.extend({
  projectId: z.string().optional(),
  projectName: z.string().optional(),
  companyId: z.string().optional(),
  companyName: z.string().optional(),
})
export type ProjectReportRow = z.infer<typeof ProjectReportRowSchema>

export const CompanyReportRowSchema = ReportTotalsSchema.extend({
  companyId: z.string().optional(),
  companyName: z.string().optional(),
})
export type CompanyReportRow = z.infer<typeof CompanyReportRowSchema>

// Субъекты среза по сотрудникам — только сотрудники: гостей и заказчиков в
// отчёте нет. Разбивка по проектам и компаниям приезжает вместе со строкой:
// каждый разрез покрывает итог сотрудника целиком.
export const EmployeeReportRowSchema = ReportTotalsSchema.extend({
  subject: z.string(),
  username: z.string(),
  fullName: z.string(),
  projects: z.array(ProjectReportRowSchema).default([]),
  companies: z.array(CompanyReportRowSchema).default([]),
})
export type EmployeeReportRow = z.infer<typeof EmployeeReportRowSchema>

function sliceOf<Row extends z.ZodType>(row: Row) {
  return z.object({ rows: z.array(row).default([]) })
}

export const EmployeeReportSchema = sliceOf(EmployeeReportRowSchema)
export type EmployeeReport = z.infer<typeof EmployeeReportSchema>

export const ProjectReportSchema = sliceOf(ProjectReportRowSchema)
export type ProjectReport = z.infer<typeof ProjectReportSchema>

export const CompanyReportSchema = sliceOf(CompanyReportRowSchema)
export type CompanyReport = z.infer<typeof CompanyReportSchema>
